(function () {
  const BP = '(min-width: 750px)';
  const mq =
    typeof window.matchMedia === 'function' ? window.matchMedia(BP) : null;

  /**
   * @param {HTMLElement} root
   */
  function initThreeCatCards(root) {
    const swiperEl = root.querySelector('.three-cat-cards__swiper');
    if (!swiperEl || typeof window.Swiper !== 'function') return;

    const prev = swiperEl._threeCatSwiper;
    if (prev && typeof prev.destroy === 'function') {
      try {
        prev.destroy(true, true);
      } catch (_) {}
      swiperEl._threeCatSwiper = null;
    }

    if (mq && mq.matches) return;

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    const count = slides.length;
    if (count === 0) return;

    const loop = count > 1;

    swiperEl._threeCatSwiper = new window.Swiper(swiperEl, {
      loop,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 8,
      watchOverflow: true,
      observer: true,
      observeParents: true,
    });
  }

  function initAll() {
    document
      .querySelectorAll('[data-three-cat-cards]')
      .forEach(initThreeCatCards);
  }

  function onResize() {
    document
      .querySelectorAll('[data-three-cat-cards]')
      .forEach(initThreeCatCards);
  }

  let resizeTimer;
  function debouncedResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(onResize, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('resize', debouncedResize);

  if (mq && mq.addEventListener) {
    mq.addEventListener('change', onResize);
  } else if (mq && mq.addListener) {
    mq.addListener(onResize);
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root =
      event.target &&
      event.target.querySelector &&
      event.target.querySelector('[data-three-cat-cards]');
    if (root) initThreeCatCards(root);
  });

  document.addEventListener('balance:gender-change', function () {
    requestAnimationFrame(function () {
      document
        .querySelectorAll('[data-three-cat-cards]')
        .forEach(function (root) {
          const el = root.querySelector('.three-cat-cards__swiper');
          if (el && el._threeCatSwiper) {
            try {
              el._threeCatSwiper.update();
            } catch (_) {}
          } else if (!mq || !mq.matches) {
            initThreeCatCards(root);
          }
        });
    });
  });
})();
